import { useNavigate, useParams } from 'react-router-dom';

//components
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';
import { useRef } from 'react';

const DeleteProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toastDelete = useRef(null);

  const confirmDelete = (event) => {
    confirmPopup({
      target: event.currentTarget,
      message: 'Sei sicuro di voler eliminare questo progetto?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      acceptClassName: 'p-button-danger',
      accept: handleDelete,
      reject: () => {
        toastDelete.current.show({
          severity: 'info',
          summary: 'Annullato',
          detail: 'Eliminazione annullata.',
          life: 3000,
        });
      },
    });
  };

  const handleDelete = () => {
    ProjectManagementService.deleteProject(id, () => {
      toastDelete.current.show({
        severity: 'success',
        summary: 'Successo',
        detail: 'Progetto eliminato con successo!',
        life: 3000,
      });
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
    });
  };

  return (
    <>
      <Toast ref={toastDelete} />
      <ConfirmPopup />
      <Button
        severity="danger"
        className="prompt__DeleteButton"
        onClick={confirmDelete}
        type="button"
      >
        Elimina
      </Button>
    </>
  );
};

export default DeleteProject;
